import React, { useEffect, useState } from "react";
import {
	Box,
	CircularProgress,
	Container,
	Fade,
	Grid,
	IconButton,
} from "@mui/material";
import Page from "../../../components/Page";
import { useNavigate } from "react-router-dom";
import { getEscoles } from "../../../database/API";
import Title from "../../../components/Title";
import { Add } from "@mui/icons-material";
import EscolaItem from "./EscolaItem";

const EscolesView = () => {
	const navigate = useNavigate();
	const [escoles, setEscoles] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const get = async () => {
			const { escoles, message } = await getEscoles();
			setEscoles(escoles);
			setLoading(false);
		};

		get();
	}, [navigate]);

	return (
		<Page title={"Escoles"}>
			<Container maxWidth={false}>
				<Title
					title={"Escoles"}
					subtitle={"Administra les escoles"}
					button={
						<Box>
							<IconButton onClick={() => navigate("nou")}>
								<Add />
							</IconButton>
						</Box>
					}
				/>
				<Box pt={2} spacing={3}>
					{!loading ? (
						<Fade in={!loading}>
							<Grid container spacing={4}>
								{escoles?.map((item) => {
									return <EscolaItem item={item} />;
								})}
							</Grid>
						</Fade>
					) : (
						<CircularProgress />
					)}
				</Box>
			</Container>
		</Page>
	);
};

export default EscolesView;
